import React from 'react';
import { FileCheckIcon, PhoneIcon, BotIcon, MailIcon, CheckIcon } from 'lucide-react';
const CapabilityCard = ({
  icon,
  title,
  description,
  bullets
}) => {
  return <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm" data-id="element-30">
      <div className="bg-orange-50 w-14 h-14 rounded-xl flex items-center justify-center mb-6" data-id="element-31">
        {icon}
      </div>
      <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-32">{title}</h3>
      <p className="text-gray-600 mb-6" data-id="element-33">{description}</p>
      <ul className="space-y-3" data-id="element-34">
        {bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-35">
            <CheckIcon size={18} className="text-orange-500 flex-shrink-0 mt-1" data-id="element-36" />
            <span className="text-gray-700 text-sm" data-id="element-37">{bullet}</span>
          </li>)}
      </ul>
    </div>;
};
const defaultCapabilities = [{
  icon: <FileCheckIcon size={28} className="text-orange-500" data-id="element-38" />,
  title: 'AI Document Validation',
  description: 'Advanced verification and validation:',
  bullets: ['Validate document data against form responses', 'Detect mismatches and missing evidence', 'Cross-reference multiple documents automatically']
}, {
  icon: <PhoneIcon size={28} className="text-orange-500" data-id="element-39" />,
  title: 'Voice & "Call-Us" Form Experiences',
  description: 'Voice-based form completion:',
  bullets: ['The form asks questions', 'Users respond naturally by speaking', 'AI captures, validates, and structures responses']
}, {
  icon: <BotIcon size={28} className="text-orange-500" data-id="element-40" />,
  title: 'Fluid Sales & Intake Agents',
  description: 'Agents that guide users while keeping output structured.',
  bullets: ['Handle clarifying questions and objections', 'Keep users moving (less drop-off)', 'Built for revenue + compliance workflows']
}, {
  icon: <MailIcon size={28} className="text-orange-500" data-id="element-41" />,
  title: 'Email-to-Form & Ad-Hoc Document Intake',
  description: 'Turn inbound documents into structured submissions.',
  bullets: ['Email documents into a form intake', 'Extract, validate, and summarize contents', 'Useful for ops, legal, and accounting teams']
}];
const AdvancedCapabilities = ({
  headline,
  subheadline,
  capabilities
}: {
  headline?: string;
  subheadline?: string;
  capabilities?: {
    icon: React.ReactNode;
    title: string;
    description: string;
    bullets: string[];
  }[];
}) => {
  const items = capabilities || defaultCapabilities;
  return <section className="w-full bg-gray-50 py-[5.75rem]" data-id="element-42">
      <div className="container mx-auto px-4" data-id="element-43">
        <div className="text-center mb-16" data-id="element-44">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-45">
            {headline || 'Advanced & Enterprise Capabilities'}
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed" data-id="element-46">
            {subheadline || 'For compliance-heavy workflows, high volume, or high-touch onboarding — add advanced capabilities without rebuilding your intake stack.'}
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-47">
          {items.map((cap, index) => <CapabilityCard key={index} {...cap} data-id="element-48" />)}
        </div>
      </div>
    </section>;
};
export default AdvancedCapabilities;